import $axios from "../api/accessor";
import { $api } from "../api/api";

export const CorporateService = {
  async getCorporate() {
    const response = await $axios.get($api("get_corporate"));
    return response;
  },
};
